'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactChartjs = require('react-chartjs');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _PlanScorecardSustainableAccess = require('./PlanScorecardSustainableAccess.css');

var _PlanScorecardSustainableAccess2 = _interopRequireDefault(_PlanScorecardSustainableAccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardSustainableAccess = (_dec = (0, _reactCssModules2.default)(_PlanScorecardSustainableAccess2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardSustainableAccess, _Component);

  function PlanScorecardSustainableAccess(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardSustainableAccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardSustainableAccess.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardSustainableAccess)).call(this, props));

    var planData = props.planData;
    var plan_option_sri_count = planData.plan_option_sri_count,
        plan_option_count = planData.plan_option_count;

    var hasSustainableFundOptions = plan_option_sri_count && plan_option_sri_count > 0;

    _this.state = {
      allocationStats: props.allocationStats,
      alertColor: hasSustainableFundOptions ? 'yellow' : 'red',
      alertText: hasSustainableFundOptions ? 'Only ' + plan_option_sri_count + ' / ' + plan_option_count + ' plan options\n          report a sustainability mandate.' : 'No plan options report a sustainability mandate.',
      ledeText: hasSustainableFundOptions ? 'But it\'s important to make sure sustainable funds are actually meeting your standards. The scorecard for any plan options marketed as sustainable can be seen below.' : 'This plan has no investment options marketed as sustainable.'
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardSustainableAccess, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          allocationStats = _state.allocationStats,
          alertColor = _state.alertColor,
          alertText = _state.alertText,
          ledeText = _state.ledeText;

      //

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'results-subtitle' },
          _react2.default.createElement(
            'h2',
            { styleName: 'results-subtitle-lbl' },
            'Access to sustainable funds'
          ),
          _react2.default.createElement('div', { styleName: 'results-subtitle-clrbr' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'sublede-sustainable-count' },
          _react2.default.createElement(
            'div',
            { styleName: 'sublede-sustainable-count-icon ' + alertColor },
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-exclamation-triangle fa-3x', nospace: true })
          ),
          _react2.default.createElement(
            'h3',
            { styleName: 'sublede-sustainable-count-text' },
            alertText
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'chart-headline' },
          _react2.default.createElement(_reactChartjs.Doughnut, {
            data: [{ value: allocationStats.sri.perc,
              // label: 'Sustainable',
              color: '#313131' }, { value: allocationStats.sri.percOther,
              // label: 'Other',
              color: '#D5D5D5' }],
            options: _config2.default.chartOptions,
            width: '150',
            height: '150'
          }),
          _react2.default.createElement(
            'div',
            null,
            allocationStats.sri.percStr === 'NaN%' ? null : _react2.default.createElement(
              'h3',
              { styleName: 'chart-headline-text' },
              allocationStats.sri.percStr,
              ' of plan assets are invested in sustainable options.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'chart-sublede' },
              'While many people stick with the target date option, 401(k)s and other employer-offered retirement plans usually have a line-up of additional investment options. Some of these investment options may be marketed as "sustainable", "socially responsible", or "ESG" (short for environment, social, and governance). Sustainable funds often seek to avoid investments in high-carbon companies and other environmentally and socially risky industries. ',
              ledeText
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardSustainableAccess;
}(_react.Component), _class2.propTypes = {
  planData: _react.PropTypes.object.isRequired,
  allocationStats: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardSustainableAccess;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardSustainableAccess/PlanScorecardSustainableAccess.js
// module id = 1428
// module chunks = 0